import styled from "styled-components";
import {
  Color,
  Font,
  breakpoints,
  backBanner,
  ColorDark,
} from "@/shared/Constants";

export const Menu = styled.div`
  background: #fff;
  border-bottom: 1px solid #ccc;
  border-bottom: none;
  height: ${(props) => (props.isHome ? "90px" : "70px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background: ${ColorDark.darkGrey};
    }
  }
  ${breakpoints.phone} {
    background: #f5f5f5;
    height: 66px;
    width: 100%;
    z-index: 11;
    h1 {
      margin-left: 15px;
      ${breakpoints.mobileFirst} {
        margin-left: 20px;
      }
    }
  }

  svg {
    width: 140px;
    height: 33px;
  }

  ${breakpoints.mobileFirst} {
    svg {
      width: ${(props) =>
        props.isHome
          ? "227px"
          : "140px"}; // medida por dafault para el logo clarin en el header
      height: ${(props) =>
        props.isHome
          ? "50px"
          : "35px"}; // medida por dafault para el logo clarin en el header

      /*  width: ${(props) =>
        props.isHome
          ? "212px"
          : "100px"}; */ // medida de logo clarin 80 aniversario en el header
      /* height: ${(props) =>
        props.isHome
          ? "50px"
          : "35px"};  */ // medida de logo clarin 80 aniversario  en el header
    }
  }
  @keyframes headAnimationSticky {
    0% {
      opacity: 0.3;
      transform: translateY(-100%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &.sticky {
    .container-sticky {
      display: flex;
      background: #f5f5f5;
      height: 70px;
      left: 0;
      position: fixed;
      width: 100%;
      z-index: 11;
      top: 50px; ///esta es la altura fija del banner
      //animation: headAnimationSticky 0.7s ease-in-out;
      ${breakpoints.mobileFirst} {
        animation: headAnimationSticky 0.7s ease-in-out;
        top: 0px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background: ${ColorDark.darkGrey};
        }
      }
      svg {
        width: ${(props) => (props.isHome ? "140px" : "")};
        height: ${(props) => (props.isHome ? "33px" : "33px")};
      }
      @keyframes headAnimationSticky {
        0% {
          opacity: 0.3;
          transform: translateY(-100%);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .subscription {
        display: none;
      }
    }
    &.bannerDisabled {
      ${breakpoints.phone} {
        .container-sticky {
          top: 0 !important;
        }
      }
    }
  }

  &.bannerDisabled {
    ${breakpoints.phone} {
      top: 0 !important;
    }
    /*.container-sticky {
      ${breakpoints.phone} {
        top: 0;
      }
    }*/
  }
  .containerCenter {
    position: relative;
    display: flex;
    justify-content: space-between;
    .contentUser {
      ${breakpoints.mobileFirst} {
        display: flex;
        align-items: center;
        width: auto;
        li.subscription {
          a.suscripcion365 {
            background: url("https://images.clarin.com/collections/images/5ec55dd7bab5780006be938c.png")
              no-repeat;
            width: 44px;
            height: 40px;
            background-size: 90%;
            display: inline-block;
            margin-left: 15px;
          }
        }
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            button {
              border: 1px solid ${ColorDark.grey};
            }
            svg {
              fill: ${ColorDark.grey};
            }
          }
        }
      }
    }
  }
  &.section-80aniversario {
    a {
      margin-left: 15px;
      display: flex;
      justify-content: flex-start;
      svg {
        height: 50px;
        ${breakpoints.phone} {
          height: 40px;
          margin-left: -5px;
        }
      }
    }
    .contentUser {
      display: flex;
      align-items: center;
    }
  }

  //ULTIMO CAMBIO DEL HEADER
  ${breakpoints.desktop} {
    &.bannerWithSubheaderDisabled {
      .container-sticky {
        top: 200px;
        transition:
          padding 0.4s ease,
          background-color 0.4s ease;
      }
    }
    &.bannerWithSubheaderDisabled.stickyWithBanner {
      .container-sticky {
        top: 0px;
        transition: all 0.5s ease;
        transform: translateY(0);
        z-index: 10000;
      }
    }
  }
`;
export const ContentLeft = styled.div`
  display: flex;
  align-items: center;

  &.logoClarin-shrink {
    .side-menu-label {
      ${breakpoints.phone} {
        margin-top: 3px;
      }
    }
  }
  ${breakpoints.phone} {
    span {
      margin-left: 20px;
      a {
        display: flex;
      }
    }
  }

  ${breakpoints.phone} {
    span {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      label svg {
        fill: ${ColorDark.grey};
      }
    }
  }
`;

export const Logo = styled.a`
  /*   margin-left: 15px;  */ // margen por default para el logo clarin en el header

  // margen para el logo clarin 80 aniversario en el header
  margin-left: ${({ variant }) => {
    switch (variant) {
      case "sticky":
        return "15px";
      case "home":
        return "15px";
      default:
        return "15px";
    }
  }};

  ${breakpoints.phone} {
    margin-left: 15px;
  }

  .sticky & {
    ${breakpoints.phone} {
      margin-left: 15px;
    }
  }

  &.logoClarin-shrink {
    display: flex;
    flex-direction: row;
    align-items: center;
    div {
      //margin-bottom: 4px;
      ${breakpoints.phone} {
        margin-bottom: -4px;
      }
    }
    ${breakpoints.phone} {
      margin-left: 6px;
    }
    ${breakpoints.mobileFirst} {
      margin-left: 17px;
      margin-bottom: 4px;
    }
    svg {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      ${breakpoints.phone} {
        width: 23px;
        height: 23px;
        margin-right: 5px;
      }
    }
    h2,
    p,
    h1 {
      font-size: 35px;
      ${Font.clarinVarSub2ExtraBold}
      color: ${Color.mainColor};
      margin-top: -3px;
      margin-left: 0;
      border-left: 1px solid red;
      padding-left: 15px;
      margin-left: 5px;
      ${breakpoints.phone} {
        font-size: 32px;
        line-height: 12px;
        margin-top: 0;
        border-left: none;
        padding-left: unset;
        margin-left: unset;
      }
    }
  }
  .tagTitleDesktop {
    display: flex;
  }
  /* ${breakpoints.mobileFirst} {
    a > div > svg {
      width: 129px;
    }
  } */
`;

export const SectionSeparatorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding: 15px 0;

  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      border-bottom: 1.6px solid ${ColorDark.greySeparator};
    }
  }

  ${breakpoints.phone} {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

export const Section = styled.a`
  color: ${Color.black000};
  ${Font.sansBold}
  font-size: 20px;
  line-height: 27px;

  flex: 1;
  min-width: 0;

  ${breakpoints.mobileFirst} {
    font-size: 25px;
    line-height: 40px;
  }

  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      color: ${ColorDark.textLight};
    }
  }
`;

export const SectionScroll = styled.a`
  display: none;
  ${breakpoints.mobileFirst} {
    align-items: center;
    color: ${Color.black000};
    display: flex;
    ${Font.sansBold}
    font-size: 25px;
    //margin-left: 0.75rem;
    &:before {
      content: "";
      background-color: ${Color.black000};
      height: 32px;
      width: 1px;
      display: block;
      margin: 4px 15px 0;
    }
  }
`;

export const HeaderStyle = styled.header`
  margin-bottom: 30px;
  &:has(~ .Nota-Mega),
  &:has(~ * .Nota-Mega) {
    margin: 0;
  }
  ${breakpoints.phone} {
    margin-bottom: 4px;
  }
  .spacer {
    ${breakpoints.phone} {
      height: 50px;
    }
  }
  .bannerTopHeader {
    ${backBanner};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 100%;
    overflow: hidden;
    position: sticky;
    top: 0;
    height: 50px;
    box-sizing: border-box;
    z-index: 9999;
    /* animation: headAnimationSticky 0.7s ease-out; */
    &.no-sticky {
      z-index: 9999;
    }
    ${breakpoints.mobileFirst} {
      min-height: 200px;
      height: unset;
      position: sticky;
    }
    @media (max-width: 974px) {
      //animation: headAnimationSticky 0.7s ease-in-out;
      left: 0;
      position: fixed;
      top: 0;
      z-index: 11;
    }
  }
  header {
    > div {
      align-items: center;
      padding: 0 33px;
    }
  }

  header .top {
    background: #191919;
    height: 50px;
    color: #fff;
  }
  header .middle {
    background: #cfcfcf;
    height: 50px;
    ul {
      margin-left: 20px;
      display: flex;
      gap: 12px;
    }
  }
  header .bottom {
    background: #fff;
    border-bottom: 1px solid #ccc;
    border-bottom: none;
    margin: 20px 0;
    svg {
      width: 227px;
      height: 50px;
    }
  }
`;
export const AppHeaderStyle = styled.div`
  margin-bottom: 30px;
  .bannerTopHeader {
    ${backBanner};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    overflow: hidden;
    ${breakpoints.mobileFirst} {
      min-height: 200px;
      height: unset;
    }
  }
`;
